import React from "react";
import bannerAntiFraude from "assets/images/banner-anti-fraude.jpg";

import {
  ContentBannerAntiFraude,
  ImageBannerAntiFraude,
  LinkAntiFraude,
} from "./styles";

const BannerFraude: React.FC = () => {
  return (
    <ContentBannerAntiFraude>
      <LinkAntiFraude
        href="https://www.ultragaz.com.br/golpe-do-boleto-falso-como-se-proteger"
        rel="noreferrer"
        target="_blank"
      >
        <ImageBannerAntiFraude src={bannerAntiFraude} />
      </LinkAntiFraude>
    </ContentBannerAntiFraude>
  );
};

export default BannerFraude;
